import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import { useParams } from "react-router-dom";
import { API_URL } from "..";
import QuoteEditLayer from "../components/QuoteEditLayer";




const QuoteEditPage = () => {
  const {id}= useParams();

  const [data, setData] = useState({})

  const fetchSingle = async()=>{
    const user = JSON.parse(localStorage.getItem('user'))
      
      let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch(API_URL+`/api/invoice/${id}/`, { 
         method: "GET",
         headers: headersList
       });
       const data = await response.json();
       if(response.status ===200){
         setData(data)
        }else{
         setData([])

       }
     }

     useEffect(()=>{
      fetchSingle()
     },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Quote - Edit" />

        {/* InvoiceEditLayer */}
        {
          data?.invoice_number === undefined ? (
            <div className="card basic-data-table p-5 text-center my-4">
              <div className="d-flex flex-column align-items-center justify-content-center py-4">
                <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <h6 className="text-muted fw-semibold">Loading Quote Details...</h6>
              </div>
            </div>
          ) : (
            <QuoteEditLayer invoiceData={data} invoiceID={id}/>
          )
        }

      </MasterLayout>

    </>
  );
};

export default QuoteEditPage;
